var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgColorCodedCardConf = function SvgColorCodedCardConf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "557px",
    height: "650px",
    viewBox: "0 0 557 650",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Illustration")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 330,
    height: 377,
    rx: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.1%",
    y: "-11.4%",
    width: "132.1%",
    height: "128.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0707768794 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 55,
    height: 55,
    rx: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 330,
    height: 377,
    rx: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.1%",
    y: "-11.4%",
    width: "132.1%",
    height: "128.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0707768794 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 55,
    height: 55,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8571429,10.0393701 L22.8571429,5.8617874 C22.8571429,2.60381102 20.5016327,0 12.244898,0 C3.98816327,0 1.63265306,2.60381102 1.63265306,5.8617874 L1.63265306,10.0393701 C1.63265306,10.0393701 0,10.1578346 0,11.2440945 L0,15.689126 C0,16.7749843 0.408163265,17.6692913 1.63265306,17.6692913 C1.63265306,23.0989843 6.54,29.3149606 12.244898,29.3149606 C17.9497959,29.3149606 22.8571429,23.0989843 22.8571429,17.6692913 C24.0816327,17.6692913 24.4897959,16.7749843 24.4897959,15.689126 L24.4897959,11.2440945 C24.4897959,10.1578346 22.8571429,10.0393701 22.8571429,10.0393701 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0,
    y: 0,
    width: 330,
    height: 377,
    rx: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.1%",
    y: "-11.4%",
    width: "132.1%",
    height: "128.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0707768794 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0,
    y: 0,
    width: 55,
    height: 55,
    rx: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intro-screen---01",
    transform: "translate(-710.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(742.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient#1",
    opacity: 0.3,
    transform: "translate(163.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "background/green-20",
    transform: "translate(150.000000, 128.000000)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FB816B",
    transform: "translate(21.500000, 118.000000) rotate(90.000000) translate(-21.500000, -118.000000) ",
    x: -96,
    y: 97,
    width: 235,
    height: 42,
    rx: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 11.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/healty"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.431813,1.58478261 L18.431813,1.58478261 C16.4308646,-0.52826087 13.1216038,-0.52826087 11.1206554,1.58478261 L10.1201812,2.68043478 C10.0432217,2.75869565 9.81234302,2.75869565 9.73538347,2.68043478 L8.73490928,1.58478261 C6.7339609,-0.52826087 3.50165967,-0.52826087 1.50071129,1.58478261 L1.50071129,1.58478261 C-0.500237095,3.69782609 -0.500237095,7.14130435 1.50071129,9.25434783 L2.73206413,10.5065217 L9.81234302,17.9413043 C9.88930257,18.0195652 10.1201812,18.0195652 10.1971408,17.9413043 L17.2774197,10.5065217 L18.5087725,9.25434783 C20.5097209,7.14130435 20.5097209,3.69782609 18.431813,1.58478261 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5 8.4 7.35714286 8.4 8.92857143 6.8 10.5 10 12.0714286 6 13.6428571 8.4 16 8.4"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Healthy")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 153,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268.605994,
    y: 25.4
  }, "0.00")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(11.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/cold"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 18.5,
    y2: 0.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 17,
    x2: 2,
    y2: 19,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 9,
    y2: 19,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18,
    x2: 5,
    y2: 14,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "3 12.5 9.85714286 6 13 9.14285714 6.14285714 15.6428571"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Cold")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 153,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268.605994,
    y: 25.4
  }, "0.84")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 11.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/flu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7398374,0.454407046 L3.98373984,9.72720352 L3.41463415,12.4317692 L0,16.8363475 L2.27642276,19 L6.91056911,15.7545212 L9.75609756,15.2136081 L19.5121951,5.94081163 C20.1626016,5.3226252 20.1626016,4.39534555 19.5121951,3.77715912 L16.097561,0.53168035 C15.4471545,-0.163779385 14.3902439,-0.163779385 13.7398374,0.454407046 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(11.050648, 8.511649) rotate(45.000000) translate(-11.050648, -8.511649) ",
    points: "10.3019372 5.36296148 11.8814093 5.34244885 11.7993588 11.660337 10.2198867 11.6808496"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 15,
    y2: 5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14,
    x2: 5,
    y2: 17,
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Flu")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 153,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268.605994,
    y: 25.4
  }, "2.49")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon-",
    transform: "translate(0.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(26.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon/bronchitis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11.3346031 C8,12.1680634 8,11.6818782 8,12.7237036 C8,17.4466454 6.54545455,17.7939205 4.36363636,17.7939205 C2.32727273,17.7939205 0,21.822312 0,15.1546295 C0,8.48694705 3.78181818,3 6.03636364,3 C6.61818182,3 7.12727273,3.20836508 7.41818182,4.31964549",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.3346031 C10,12.1680634 10,11.6818782 10,12.7237036 C10,17.4466454 11.4545455,17.7939205 13.6363636,17.7939205 C15.6727273,17.7939205 18,21.822312 18,15.1546295 C18,8.48694705 14.2181818,3 12.0363636,3 C11.4545455,3 10.9454545,3.20836508 10.6545455,4.31964549",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L9,4.71428571 C9,5.78571429 8.53333333,6.85714286 7.73333333,7.57142857 L5,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,5 C9,6.01351351 9.46666667,7.02702703 10.2666667,7.7027027 L13,10",
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Bronchitis")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 153,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 269.105994,
    y: 25.4
  }, "0.15")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(15.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/cancer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0875,0 L10.0875,0 C11.1875,0.825 11.1875,2.175 10.0875,3 L10.0875,3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L3,3 C4.14285714,3 5,3.92857143 5,5 L5,5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.9125 L0,9.9125 C0.825,8.8125 2.175,8.8125 3,9.9125 L3,9.9125",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,17 L3,17 C3,15.8571429 3.92857143,15 5,15 L5,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9125,20 L9.9125,20 C8.8125,19.175 8.8125,17.825 9.9125,17 L9.9125,17",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,17 L17,17 C15.8571429,17 15,16.0714286 15,15 L15,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,10.0875 L20,10.0875 C19.175,11.1875 17.825,11.1875 17,10.0875 L17,10.0875",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,3 L17,3 C17,4.14285714 16.0714286,5 15,5 L15,5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.475,10 C13.775,9.65714286 14,9.22857143 14,8.71428571 C14,7.77142857 13.325,7 12.5,7 C11.675,7 11,7.77142857 11,8.71428571 C11,9.22857143 11.225,9.65714286 11.525,10 C11.225,10.3428571 11,10.7714286 11,11.2857143 C11,12.2285714 11.675,13 12.5,13 C13.325,13 14,12.2285714 14,11.2857143 C14,10.7714286 13.775,10.3428571 13.475,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 9,
    y2: 6,
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 25
  }, "Cancer")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 138,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 194,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 249.610398,
    y: 25.4
  }, "4.94")))), /*#__PURE__*/React.createElement("g", {
    id: "table/head",
    transform: "translate(153.000000, 97.400000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Prob.")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 13
  }, "LG")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 112,
    y: 13
  }, "ELG")), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 27.1,
    x2: 146.5,
    y2: 27.1,
    id: "Line",
    stroke: "#404D66",
    opacity: 0.05,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "User/info",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Female-avatar-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doctor_icon-icons.com_55045"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.347222, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.652778, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2182857,16.1591418 C29.385,15.2700013 29.4767143,14.3536038 29.4912857,13.4169986 C29.4947143,13.3272387 29.4985714,13.2355989 29.4985714,13.1585276 C29.4985714,12.0714526 29.3920075,11.048358 29.189549,10.0905138 C27.7967999,3.50132913 21.8608688,0 14.7488571,0 C6.603,0 0,4.59326601 0,13.1585276 C0,14.1924119 0.0981428571,15.2018589 0.281571429,16.1788796 C1.07742857,22.4188413 3.16457143,34.6614414 1.12242857,36.9007408 C3.37757143,39.374074 14.7492857,36.9007408 14.7492857,36.9007408 C14.7492857,36.9007408 26.121,39.374074 28.3761429,36.9007408 C26.331,34.6586217 28.4241429,22.3925243 29.2182857,16.1591418 Z",
    id: "Path",
    fill: "#5A4B4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2338846,33.2602482 L19.236,33.2602482 L17.7878077,28.7531825 L13.9801154,28.4712263 L13.2397308,28.5258394 L16.3070385,28.7531825 L17.7552308,33.2602482 L17.7531154,33.2602482 C17.7746923,33.3220584 17.7878077,33.3851387 17.7878077,33.4477956 C17.7878077,34.3012847 15.8086538,35.0044818 13.2397308,35.1200584 C13.4821538,35.1306423 13.7279615,35.1382628 13.9801154,35.1382628 C16.9001923,35.1382628 19.2685769,34.3817226 19.2685769,33.4477956 C19.2685769,33.3847153 19.2554615,33.3220584 19.2338846,33.2602482 Z",
    id: "Path",
    fill: "#D9BFB8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2338846,33.2602482 L19.236,33.2602482 L17.7878077,28.7531825 L13.9801154,28.4712263 L10.1724231,28.7531825 L8.72423077,33.2602482 L8.72634615,33.2602482 C8.70476923,33.3220584 8.69165385,33.3851387 8.69165385,33.4477956 C8.69165385,34.3817226 11.0596154,35.1382628 13.9801154,35.1382628 C16.9001923,35.1382628 19.2685769,34.3817226 19.2685769,33.4477956 C19.2685769,33.3847153 19.2554615,33.3220584 19.2338846,33.2602482 Z",
    id: "Path",
    fill: "#E6CBC3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.007429, 0.000000)",
    fill: "#463B3B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9916927,13.1590593 C15.9916927,4.59345162 9.22236053,0 0.871306051,0 C0.576051218,0 0.283432589,0.00751946244 -0.00742857143,0.0187986561 C7.93413558,0.331326314 14.2342234,4.89610998 14.2342234,13.1590593 L14.2351022,13.1590593 C14.2351022,13.2361338 14.2311479,13.3277772 14.2276329,13.4175408 C14.2126945,14.3541838 14.1186698,15.2706183 13.947756,16.1597948 C13.1336083,22.3943691 10.9886171,34.6600222 13.0835205,36.9017619 C12.4191971,37.6128211 10.9820266,37.9131296 9.27244841,37.9831546 C11.7113763,38.0686885 13.9578614,37.8463944 14.8409897,36.9017619 C12.7452076,34.6600222 14.8910776,22.3943691 15.7052252,16.1597948 C15.8761391,15.2706183 15.9701637,14.3541838 15.9851022,13.4175408 C15.9886171,13.3277772 15.9925714,13.2361338 15.9925714,13.1590593 L15.9916927,13.1590593 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.686,9.21428571 C13.1502857,16.7858571 0,14.9464286 0,19.9624286 C1.45714286,25.9907143 6.40757143,30.4285714 12.2931429,30.4285714 C19.2531429,30.4285714 24.9051429,24.2228571 25.0178571,16.5201429 C18.4821429,15.7152857 14.6091429,10.3427143 13.686,9.21428571 Z",
    id: "Path",
    fill: "#FFE1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.686,9.21428571 C13.1502857,16.7858571 0,14.9464286 0,19.9624286 C0.0231428571,20.0575714 0.0488571429,20.151 0.0741428571,20.2452857 C1.10271429,15.954 13.7378571,17.472 13.686,9.21428571 Z",
    id: "Path",
    fill: "#F2D6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.686,9.21428571 C14.6091429,10.3427143 17.172,16.3941429 23.7077143,17.1985714 C23.5984286,24.6522857 18.3248571,30.0685714 11.6772857,30.411 C11.8817143,30.4217143 12.0865714,30.4285714 12.2935714,30.4285714 C19.2535714,30.4285714 24.9055714,24.2228571 25.0182857,16.5201429 C18.4821429,15.7152857 14.6091429,10.3427143 13.686,9.21428571 Z",
    id: "Path",
    fill: "#F2D6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8422857,24.7071429 C18.0852857,25.0778571 15.7482857,27.1697143 12.2931429,27.1697143 C8.838,27.1697143 6.501,25.0778571 6.74485714,24.7071429 C6.98871429,24.336 9.34628571,25.5625714 12.2931429,25.5625714 C15.24,25.5625714 17.5988571,24.3364286 17.8422857,24.7071429 Z",
    id: "Path",
    fill: "#E6BAAD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.293143, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: 1.73333333,
    cy: 1.5,
    rx: 1.73333333,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000000",
    cx: 1.73333333,
    cy: 1.5,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.533333, 0.000000)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: 1.73333333,
    cy: 1.5,
    rx: 1.73333333,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000000",
    cx: 1.73333333,
    cy: 1.5,
    rx: 1,
    ry: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.652778, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8325769,10.7591241 C43.8957308,1.02189781 29.3698077,2.2919708 25.9801154,2.2919708 C22.5904231,2.2919708 8.0645,1.02189781 6.12765385,10.7591241 C4.19080769,20.4963504 13.8754615,23.8832117 13.8754615,23.8832117 L25.9801154,23.8832117 L38.0847692,23.8832117 C38.0847692,23.8832117 47.7694231,20.4963504 45.8325769,10.7591241 Z",
    id: "Path",
    fill: "#CFCFCF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,1.86861314 C17.8333333,1.95620438 14.4487179,2.52068127 10.3461538,3.5620438 C6.24358974,4.60340633 2.96153846,8.41605839 0.5,15 L4,26 L26,26 L26,16.6632701 L24.7493846,14.9927007 L20.5,1.86861314 Z",
    id: "Path",
    fill: "#F5F5F5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,2 C43.3333333,2.08759124 39.9487179,2.65206813 35.8461538,3.69343066 C31.7435897,4.73479319 28.4615385,8.54744526 26,15.1313869 L29.5,26.1313869 L51.5,26.1313869 L51.5,16.7946569 L50.2493846,15.1240876 L46,2 Z",
    id: "Path-Copy",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    transform: "translate(38.750000, 14.065693) scale(-1, 1) translate(-38.750000, -14.065693) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692308,7.79562044 C17.1153846,7.37226277 20.5,6.10218978 20.5,6.10218978 L20.0769231,9.91240876 L26,16.6861314 C23.8846154,13.2992701 20.9230769,1.86861314 20.9230769,0.598540146 C19.0035769,1.69207299 16.2692308,4.12637956 16.2692308,7.79562044 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7307692,7.79562044 C34.8846154,7.37226277 31.5,6.10218978 31.5,6.10218978 L31.9230769,9.91240876 L26,16.6861314 C28.1153846,13.2992701 31.0769231,1.86861314 31.0769231,0.598540146 C32.9964231,1.69207299 35.7307692,4.12637956 35.7307692,7.79562044 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 70.5,
    x2: 298.5,
    y2: 70.5,
    id: "Line",
    stroke: "#404D66",
    opacity: 0.05,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Name-and-Surname",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: 0.1669683,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 34
  }, "Ashley Graham")))))), /*#__PURE__*/React.createElement("g", {
    id: "Patient#1-",
    opacity: 0.3,
    transform: "translate(0.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 11.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/healty"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.431813,1.58478261 L18.431813,1.58478261 C16.4308646,-0.52826087 13.1216038,-0.52826087 11.1206554,1.58478261 L10.1201812,2.68043478 C10.0432217,2.75869565 9.81234302,2.75869565 9.73538347,2.68043478 L8.73490928,1.58478261 C6.7339609,-0.52826087 3.50165967,-0.52826087 1.50071129,1.58478261 L1.50071129,1.58478261 C-0.500237095,3.69782609 -0.500237095,7.14130435 1.50071129,9.25434783 L2.73206413,10.5065217 L9.81234302,17.9413043 C9.88930257,18.0195652 10.1201812,18.0195652 10.1971408,17.9413043 L17.2774197,10.5065217 L18.5087725,9.25434783 C20.5097209,7.14130435 20.5097209,3.69782609 18.431813,1.58478261 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5 8.4 7.35714286 8.4 8.92857143 6.8 10.5 10 12.0714286 6 13.6428571 8.4 16 8.4"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Healthy")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 153,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 265,
    y: 25.4
  }, "20.00")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(11.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/cold"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 18.5,
    y2: 0.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 17,
    x2: 2,
    y2: 19,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 9,
    y2: 19,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18,
    x2: 5,
    y2: 14,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "3 12.5 9.85714286 6 13 9.14285714 6.14285714 15.6428571"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Cold")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 153,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 265,
    y: 25.4
  }, "20.00")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 11.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/flu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7398374,0.454407046 L3.98373984,9.72720352 L3.41463415,12.4317692 L0,16.8363475 L2.27642276,19 L6.91056911,15.7545212 L9.75609756,15.2136081 L19.5121951,5.94081163 C20.1626016,5.3226252 20.1626016,4.39534555 19.5121951,3.77715912 L16.097561,0.53168035 C15.4471545,-0.163779385 14.3902439,-0.163779385 13.7398374,0.454407046 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(11.050648, 8.511649) rotate(45.000000) translate(-11.050648, -8.511649) ",
    points: "10.3019372 5.36296148 11.8814093 5.34244885 11.7993588 11.660337 10.2198867 11.6808496"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 15,
    y2: 5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14,
    x2: 5,
    y2: 17,
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Flu")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 153,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 265,
    y: 25.4
  }, "20.00")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon-",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(26.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/green-20",
    transform: "translate(124.000000, 0.000000)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FB816B",
    transform: "translate(21.500000, 118.000000) rotate(90.000000) translate(-21.500000, -118.000000) ",
    x: -96,
    y: 97,
    width: 235,
    height: 42,
    rx: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(0.000000, 157.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/bronchitis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11.3346031 C8,12.1680634 8,11.6818782 8,12.7237036 C8,17.4466454 6.54545455,17.7939205 4.36363636,17.7939205 C2.32727273,17.7939205 0,21.822312 0,15.1546295 C0,8.48694705 3.78181818,3 6.03636364,3 C6.61818182,3 7.12727273,3.20836508 7.41818182,4.31964549",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.3346031 C10,12.1680634 10,11.6818782 10,12.7237036 C10,17.4466454 11.4545455,17.7939205 13.6363636,17.7939205 C15.6727273,17.7939205 18,21.822312 18,15.1546295 C18,8.48694705 14.2181818,3 12.0363636,3 C11.4545455,3 10.9454545,3.20836508 10.6545455,4.31964549",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L9,4.71428571 C9,5.78571429 8.53333333,6.85714286 7.73333333,7.57142857 L5,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,5 C9,6.01351351 9.46666667,7.02702703 10.2666667,7.7027027 L13,10",
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 172
  }, "Bronchitis")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 157.605994,
    y: 172.4
  }, "0.05")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 208.610398,
    y: 172.4
  }, "43.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268.605994,
    y: 172.4
  }, "2.19")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(15.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/cancer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0875,0 L10.0875,0 C11.1875,0.825 11.1875,2.175 10.0875,3 L10.0875,3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L3,3 C4.14285714,3 5,3.92857143 5,5 L5,5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.9125 L0,9.9125 C0.825,8.8125 2.175,8.8125 3,9.9125 L3,9.9125",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,17 L3,17 C3,15.8571429 3.92857143,15 5,15 L5,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9125,20 L9.9125,20 C8.8125,19.175 8.8125,17.825 9.9125,17 L9.9125,17",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,17 L17,17 C15.8571429,17 15,16.0714286 15,15 L15,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,10.0875 L20,10.0875 C19.175,11.1875 17.825,11.1875 17,10.0875 L17,10.0875",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,3 L17,3 C17,4.14285714 16.0714286,5 15,5 L15,5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.475,10 C13.775,9.65714286 14,9.22857143 14,8.71428571 C14,7.77142857 13.325,7 12.5,7 C11.675,7 11,7.77142857 11,8.71428571 C11,9.22857143 11.225,9.65714286 11.525,10 C11.225,10.3428571 11,10.7714286 11,11.2857143 C11,12.2285714 11.675,13 12.5,13 C13.325,13 14,12.2285714 14,11.2857143 C14,10.7714286 13.775,10.3428571 13.475,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 9,
    y2: 6,
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 25
  }, "Cancer")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 143.105994,
    y: 25.4
  }, "0.07")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 194,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 249.610398,
    y: 25.4
  }, "14.54")))), /*#__PURE__*/React.createElement("g", {
    id: "table/head",
    transform: "translate(153.000000, 97.400000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Conf")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 13
  }, "LG")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 112,
    y: 13
  }, "ELG.")), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 27.1,
    x2: 146.5,
    y2: 27.1,
    id: "Line",
    stroke: "#404D66",
    opacity: 0.05,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "User/info",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "avatar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doctor_icon-icons.com_55045"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6CD0B7",
    opacity: 0.48953683,
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.347222, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.652778, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8325769,14.7591241 C43.8957308,5.02189781 29.3698077,6.2919708 25.9801154,6.2919708 C22.5904231,6.2919708 8.0645,5.02189781 6.12765385,14.7591241 C4.19080769,24.4963504 13.8754615,27.8832117 13.8754615,27.8832117 L25.9801154,27.8832117 L38.0847692,27.8832117 C38.0847692,27.8832117 47.7694231,24.4963504 45.8325769,14.7591241 Z",
    id: "Path",
    fill: "#CFCFCF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,5.86861314 C17.8333333,5.95620438 14.4487179,6.52068127 10.3461538,7.5620438 C6.24358974,8.60340633 2.96153846,12.4160584 0.5,19 L4,30 L26,30 L26,20.6632701 L24.7493846,18.9927007 L20.5,5.86861314 Z",
    id: "Path",
    fill: "#F5F5F5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,6 C43.3333333,6.08759124 39.9487179,6.65206813 35.8461538,7.69343066 C31.7435897,8.73479319 28.4615385,12.5474453 26,19.1313869 L29.5,30.1313869 L51.5,30.1313869 L51.5,20.7946569 L50.2493846,19.1240876 L46,6 Z",
    id: "Path-Copy",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    transform: "translate(38.750000, 18.065693) scale(-1, 1) translate(-38.750000, -18.065693) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 25.9801154,
    cy: 6.50364964,
    rx: 5.92307692,
    ry: 2.32846715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2338846,5.26024818 L31.236,5.26024818 L29.7878077,0.753182482 L25.9801154,0.471226277 L22.1724231,0.753182482 L20.7242308,5.26024818 L20.7263462,5.26024818 C20.7047692,5.32205839 20.6916538,5.38513869 20.6916538,5.44779562 C20.6916538,6.38172263 23.0596154,7.13826277 25.9801154,7.13826277 C28.9001923,7.13826277 31.2685769,6.38172263 31.2685769,5.44779562 C31.2685769,5.38471533 31.2554615,5.32205839 31.2338846,5.26024818 Z",
    id: "Path",
    fill: "#E6CBC3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2338846,5.26024818 L31.236,5.26024818 L29.7878077,0.753182482 L25.9801154,0.471226277 L25.2397308,0.525839416 L28.3070385,0.753182482 L29.7552308,5.26024818 L29.7531154,5.26024818 C29.7746923,5.32205839 29.7878077,5.38513869 29.7878077,5.44779562 C29.7878077,6.30128467 27.8086538,7.00448175 25.2397308,7.12005839 C25.4821538,7.13064234 25.7279615,7.13826277 25.9801154,7.13826277 C28.9001923,7.13826277 31.2685769,6.38172263 31.2685769,5.44779562 C31.2685769,5.38471533 31.2554615,5.32205839 31.2338846,5.26024818 Z",
    id: "Path",
    fill: "#D9BFB8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692308,11.7956204 C17.1153846,11.3722628 20.5,10.1021898 20.5,10.1021898 L20.0769231,13.9124088 L26,20.6861314 C23.8846154,17.2992701 20.9230769,5.86861314 20.9230769,4.59854015 C19.0035769,5.69207299 16.2692308,8.12637956 16.2692308,11.7956204 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7307692,11.7956204 C34.8846154,11.3722628 31.5,10.1021898 31.5,10.1021898 L31.9230769,13.9124088 L26,20.6861314 C28.1153846,17.2992701 31.0769231,5.86861314 31.0769231,4.59854015 C32.9964231,5.69207299 35.7307692,8.12637956 35.7307692,11.7956204 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(15.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFE1D9",
    fillRule: "nonzero",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76363636,-1 C9.50349091,-1 9.25098182,-0.997027397 9,-0.993630137 C18.6783273,-0.859438356 21.4727273,1.84053425 21.4727273,5.19872603 L21.4727273,9.61643836 L21.4727273,17.6849315 C21.4727273,23.2203425 15.7831273,29.5256575 9,29.9728219 C9.25352727,29.9893836 9.50756364,30 9.76363636,30 C16.8792,30 23,23.426726 23,17.6849315 L23,9.61643836 L23,5.19872603 C23,1.75347945 20.0630545,-1 9.76363636,-1 Z",
    fill: "#F2D6CE",
    fillRule: "nonzero",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.244898,5 C18.9881633,5 16.6326531,7.60381102 16.6326531,10.8617874 L16.6326531,15.0393701 L16.6326531,19.4566929 C17.0106122,17.5974016 18.0897959,12.2962126 20.5163265,10.5658268 C22.4473469,11.1087559 24.7591837,11.4251969 27.244898,11.4251969 C29.7306122,11.4251969 32.0420408,11.1083543 33.9730612,10.5658268 C36.3995918,12.2966142 37.4791837,17.5974016 37.8571429,19.4566929 L37.8571429,15.0393701 L37.8571429,10.8617874 C37.8571429,7.60381102 35.502449,5 27.244898,5 Z",
    id: "Path",
    fill: "#5A4B4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.244898,5 C27.0367347,5 26.8346939,5.00281102 26.6338776,5.00602362 C34.3926531,5.13332283 36.6326531,7.68613386 36.6326531,10.8617874 L36.6326531,14.8253307 C37.2828571,16.6436614 37.6632653,18.5029528 37.8571429,19.4566929 L37.8571429,15.0393701 L37.8571429,10.8617874 C37.8571429,7.60381102 35.502449,5 27.244898,5 Z",
    id: "Path",
    fill: "#463B3B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8587755,27.8732992 C29.9506122,28.3074016 28.7873469,28.9398819 27.244898,28.9398819 C25.702449,28.9398819 24.5391837,28.3074016 24.6306122,27.8732992 C24.7220408,27.4387953 25.8853061,27.3335827 27.244898,27.3335827 C28.6044898,27.3335827 29.7681633,27.4387953 29.8587755,27.8732992 Z",
    id: "Path",
    fill: "#CC9B8E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.264082, 17.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: 1.57142857,
    cy: 1,
    rx: 1.57142857,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000000",
    cx: 1.57142857,
    cy: 1,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.857143, 0.000000)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: 1.57142857,
    cy: 1,
    rx: 1.57142857,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000000",
    cx: 1.57142857,
    cy: 1,
    rx: 1,
    ry: 1
  })))), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 70.5,
    x2: 298.5,
    y2: 70.5,
    id: "Line",
    stroke: "#404D66",
    opacity: 0.05,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Name-and-Surname",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: 0.1669683,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 34
  }, "Clarke Gillebert")))))), /*#__PURE__*/React.createElement("g", {
    id: "Patient#1",
    transform: "translate(81.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "backgrounds",
    transform: "translate(150.000000, 128.000000)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    fill: "#FB816B",
    transform: "translate(21.500000, 118.000000) rotate(90.000000) translate(-21.500000, -118.000000) ",
    x: -96,
    y: 97,
    width: 235,
    height: 42,
    rx: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 11.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/healty"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.431813,1.58478261 L18.431813,1.58478261 C16.4308646,-0.52826087 13.1216038,-0.52826087 11.1206554,1.58478261 L10.1201812,2.68043478 C10.0432217,2.75869565 9.81234302,2.75869565 9.73538347,2.68043478 L8.73490928,1.58478261 C6.7339609,-0.52826087 3.50165967,-0.52826087 1.50071129,1.58478261 L1.50071129,1.58478261 C-0.500237095,3.69782609 -0.500237095,7.14130435 1.50071129,9.25434783 L2.73206413,10.5065217 L9.81234302,17.9413043 C9.88930257,18.0195652 10.1201812,18.0195652 10.1971408,17.9413043 L17.2774197,10.5065217 L18.5087725,9.25434783 C20.5097209,7.14130435 20.5097209,3.69782609 18.431813,1.58478261 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5 8.4 7.35714286 8.4 8.92857143 6.8 10.5 10 12.0714286 6 13.6428571 8.4 16 8.4"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Healthy")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 158.105994,
    y: 25.4
  }, "0.04")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 213.105994,
    y: 25.4
  }, "0.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268.105994,
    y: 25.4
  }, "0.00")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(11.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/cold"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 18.5,
    y2: 0.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 17,
    x2: 2,
    y2: 19,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 9,
    y2: 19,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18,
    x2: 5,
    y2: 14,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "3 12.5 9.85714286 6 13 9.14285714 6.14285714 15.6428571"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Cold")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 158.105994,
    y: 25.4
  }, "0.10")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 25.4
  }, "20.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268.105994,
    y: 25.4
  }, "2.00")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(0.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 11.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/flu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7398374,0.454407046 L3.98373984,9.72720352 L3.41463415,12.4317692 L0,16.8363475 L2.27642276,19 L6.91056911,15.7545212 L9.75609756,15.2136081 L19.5121951,5.94081163 C20.1626016,5.3226252 20.1626016,4.39534555 19.5121951,3.77715912 L16.097561,0.53168035 C15.4471545,-0.163779385 14.3902439,-0.163779385 13.7398374,0.454407046 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(11.050648, 8.511649) rotate(45.000000) translate(-11.050648, -8.511649) ",
    points: "10.3019372 5.36296148 11.8814093 5.34244885 11.7993588 11.660337 10.2198867 11.6808496"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 15,
    y2: 5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14,
    x2: 5,
    y2: 17,
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Flu")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 158.105994,
    y: 25.4
  }, "0.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 213.105994,
    y: 25.4
  }, "4.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268.605994,
    y: 25.4
  }, "0.00")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon-",
    transform: "translate(0.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background",
    transform: "translate(26.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icon/bronchitis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11.3346031 C8,12.1680634 8,11.6818782 8,12.7237036 C8,17.4466454 6.54545455,17.7939205 4.36363636,17.7939205 C2.32727273,17.7939205 0,21.822312 0,15.1546295 C0,8.48694705 3.78181818,3 6.03636364,3 C6.61818182,3 7.12727273,3.20836508 7.41818182,4.31964549",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.3346031 C10,12.1680634 10,11.6818782 10,12.7237036 C10,17.4466454 11.4545455,17.7939205 13.6363636,17.7939205 C15.6727273,17.7939205 18,21.822312 18,15.1546295 C18,8.48694705 14.2181818,3 12.0363636,3 C11.4545455,3 10.9454545,3.20836508 10.6545455,4.31964549",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L9,4.71428571 C9,5.78571429 8.53333333,6.85714286 7.73333333,7.57142857 L5,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,5 C9,6.01351351 9.46666667,7.02702703 10.2666667,7.7027027 L13,10",
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 63,
    y: 25
  }, "Bronchitis")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 157.605994,
    y: 25.4
  }, "0.67")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 208,
    y: 25.4
  }, "16.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 264,
    y: 25.4
  }, "10.72")))), /*#__PURE__*/React.createElement("g", {
    id: "table/item-with-icon",
    transform: "translate(15.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons/icon-with-background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background/transparent",
    fill: "#FFFFFF",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background/green-20",
    x: 0,
    y: 0,
    width: 299,
    height: 40,
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/healty-20",
    transform: "translate(10.000000, 10.000000)",
    opacity: 0.6,
    stroke: "#404D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/cancer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0875,0 L10.0875,0 C11.1875,0.825 11.1875,2.175 10.0875,3 L10.0875,3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L3,3 C4.14285714,3 5,3.92857143 5,5 L5,5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.9125 L0,9.9125 C0.825,8.8125 2.175,8.8125 3,9.9125 L3,9.9125",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,17 L3,17 C3,15.8571429 3.92857143,15 5,15 L5,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9125,20 L9.9125,20 C8.8125,19.175 8.8125,17.825 9.9125,17 L9.9125,17",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,17 L17,17 C15.8571429,17 15,16.0714286 15,15 L15,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,10.0875 L20,10.0875 C19.175,11.1875 17.825,11.1875 17,10.0875 L17,10.0875",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,3 L17,3 C17,4.14285714 16.0714286,5 15,5 L15,5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.475,10 C13.775,9.65714286 14,9.22857143 14,8.71428571 C14,7.77142857 13.325,7 12.5,7 C11.675,7 11,7.77142857 11,8.71428571 C11,9.22857143 11.225,9.65714286 11.525,10 C11.225,10.3428571 11,10.7714286 11,11.2857143 C11,12.2285714 11.675,13 12.5,13 C13.325,13 14,12.2285714 14,11.2857143 C14,10.7714286 13.775,10.3428571 13.475,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 9,
    y2: 6,
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "title",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 25
  }, "Cancer")), /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 142.605994,
    y: 25.4
  }, "0.19")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    opacity: 0.6,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 194,
    y: 25.4
  }, "26.00")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    opacity: 0.59734,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 249,
    y: 25.4
  }, "4.94")))), /*#__PURE__*/React.createElement("g", {
    id: "table/head",
    transform: "translate(153.000000, 97.400000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "value#1",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Conf")), /*#__PURE__*/React.createElement("text", {
    id: "value#2",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 13
  }, "LG")), /*#__PURE__*/React.createElement("text", {
    id: "value#3",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.129864233,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 112,
    y: 13
  }, "ELG")), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 27.1,
    x2: 146.5,
    y2: 27.1,
    id: "Line",
    stroke: "#404D66",
    opacity: 0.05,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "User/info",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Male-avatar-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doctor_icon-icons.com_55045"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6CD0B7",
    opacity: 0.48953683,
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-14)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.347222, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.652778, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8325769,42.7591241 C43.8957308,33.0218978 29.3698077,34.2919708 25.9801154,34.2919708 C22.5904231,34.2919708 8.0645,33.0218978 6.12765385,42.7591241 C4.19080769,52.4963504 13.8754615,55.8832117 13.8754615,55.8832117 L25.9801154,55.8832117 L38.0847692,55.8832117 C38.0847692,55.8832117 47.7694231,52.4963504 45.8325769,42.7591241 Z",
    id: "Path",
    fill: "#CFCFCF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,33.8686131 C17.8333333,33.9562044 14.4487179,34.5206813 10.3461538,35.5620438 C6.24358974,36.6034063 2.96153846,40.4160584 0.5,47 L4,58 L26,58 L26,48.6632701 L24.7493846,46.9927007 L20.5,33.8686131 Z",
    id: "Path",
    fill: "#F5F5F5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,34 C43.3333333,34.0875912 39.9487179,34.6520681 35.8461538,35.6934307 C31.7435897,36.7347932 28.4615385,40.5474453 26,47.1313869 L29.5,58.1313869 L51.5,58.1313869 L51.5,48.7946569 L50.2493846,47.1240876 L46,34 Z",
    id: "Path-Copy",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    transform: "translate(38.750000, 46.065693) scale(-1, 1) translate(-38.750000, -46.065693) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 25.9801154,
    cy: 34.5036496,
    rx: 5.92307692,
    ry: 2.32846715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2338846,33.2602482 L29.7878077,28.7531825 L25.9801154,28.4712263 L22.1724231,28.7531825 L20.7242308,33.2602482 C20.7047692,33.3220584 20.6916538,33.3851387 20.6916538,33.4477956 C20.6916538,34.3817226 23.0596154,35.1382628 25.9801154,35.1382628 C28.9001923,35.1382628 31.2685769,34.3817226 31.2685769,33.4477956 C31.2685769,33.3847153 31.2554615,33.3220584 31.2338846,33.2602482 Z",
    id: "Path",
    fill: "#E6CBC3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2338846,33.2602482 L31.236,33.2602482 L29.7878077,28.7531825 L25.9801154,28.4712263 L25.2397308,28.5258394 L28.3070385,28.7531825 L29.7552308,33.2602482 L29.7531154,33.2602482 C29.7746923,33.3220584 29.7878077,33.3851387 29.7878077,33.4477956 C29.7878077,34.3012847 27.8086538,35.0044818 25.2397308,35.1200584 C25.4821538,35.1306423 25.7279615,35.1382628 25.9801154,35.1382628 C28.9001923,35.1382628 31.2685769,34.3817226 31.2685769,33.4477956 C31.2685769,33.3847153 31.2554615,33.3220584 31.2338846,33.2602482 Z",
    id: "Path",
    fill: "#D9BFB8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,10.5839416 L37,8.89051095 C37,5.45581022 34.5584231,0 26,0 C17.4415769,0 15,5.45581022 15,8.89051095 L15,10.5839416 C15,10.5839416 13.3076923,10.7088321 13.3076923,11.8540146 L13.3076923,16.5397372 C13.3076923,17.6849197 13.7307692,18.6277372 15,18.6277372 C15,24.3523796 20.0866538,30.9051095 26,30.9051095 C31.9133462,30.9051095 37,24.3523796 37,18.6277372 C38.2692308,18.6277372 38.6923077,17.6849197 38.6923077,16.5397372 L38.6923077,11.8540146 C38.6923077,10.7088321 37,10.5839416 37,10.5839416 Z",
    id: "Path",
    fill: "#FFE1D9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,10.5839416 C37,7.62043796 37,1.69343066 32.7692308,1.69343066 C33.7854615,2.94318248 35.3076923,6.5620438 35.3076923,10.1605839 C35.3076923,11.7655328 35.4202308,12.2422336 35.7108846,12.7007299 C36.0015385,13.1592263 36.1339615,13.7946861 36.1339615,14.8175182 C36.1339615,17.3576642 34.0735769,21.9087591 30.6538462,23.2846715 C30.6538462,22.0852993 29.0165385,20.3211679 26,20.3211679 C22.9834615,20.3211679 21.3461538,22.0852993 21.3461538,23.2846715 C17.9264231,21.9087591 15.8660385,17.3576642 15.8660385,14.8175182 C15.8660385,13.7946861 15.9984615,13.1592263 16.2891154,12.7007299 C16.5797692,12.2422336 16.6923077,11.7655328 16.6923077,10.1605839 C16.6923077,6.5620438 18.2145385,2.94318248 19.2307692,1.69343066 C15,1.69343066 15,7.62043796 15,10.5839416 C15.8461538,12.2773723 15.8461538,17.7810219 15,18.6277372 C15,29.388219 22.6153846,31.3284672 26,31.3284672 C29.3846154,31.3284672 37,29.388219 37,18.6277372 M26,26.0788321 C24.3643846,26.0788321 23.0384615,25.5479416 23.0384615,24.8934307 C23.0384615,24.2389197 24.3643846,23.7080292 26,23.7080292 C27.6356154,23.7080292 28.9615385,24.2389197 28.9615385,24.8934307 C28.9615385,25.5479416 27.6356154,26.0788321 26,26.0788321 Z",
    id: "Shape",
    fill: "#463B3B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692308,39.7956204 C17.1153846,39.3722628 20.5,38.1021898 20.5,38.1021898 L20.0769231,41.9124088 L26,48.6861314 C23.8846154,45.2992701 20.9230769,33.8686131 20.9230769,32.5985401 C19.0035769,33.692073 16.2692308,36.1263796 16.2692308,39.7956204 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7307692,39.7956204 C34.8846154,39.3722628 31.5,38.1021898 31.5,38.1021898 L31.9230769,41.9124088 L26,48.6861314 C28.1153846,45.2992701 31.0769231,33.8686131 31.0769231,32.5985401 C32.9964231,33.692073 35.7307692,36.1263796 35.7307692,39.7956204 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.652778, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: 1.63265306,
    cy: 1,
    rx: 1.63265306,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000000",
    cx: 1.63265306,
    cy: 1,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.163265, 0.000000)",
    fillRule: "nonzero",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: 1.63265306,
    cy: 1,
    rx: 1.63265306,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000000",
    cx: 1.63265306,
    cy: 1,
    rx: 1,
    ry: 1
  }))))))), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 70.5,
    x2: 298.5,
    y2: 70.5,
    id: "Line",
    stroke: "#404D66",
    opacity: 0.05,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Name-and-Surname",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: 0.1669683,
    fill: "#404D66"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 34
  }, "Hubert Franck")))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorCodedCardConf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/color_coded_card_conf.6e650bff.svg";
export { ForwardRef as ReactComponent };